import React, { FC, useMemo, useContext } from 'react';

import styled from 'styled-components';

// constants
import aampeTheme from '../../../../constants/aampeTheme';
import { PREVIEW_SVG_URLS } from '../../../../constants/messagePreviews';

// context
import { EditorContext } from '../../../../context/EditorContext';

// models
import { WhatsappPreviewModel } from '../../../../models/editor.model';
import { PreviewComponentProps } from '../../../../models/formula.model';

// components
import Phone from '../shared/Phone';

const WhatsappMain: FC<
    React.PropsWithChildren<PreviewComponentProps<WhatsappPreviewModel>>
> = ({ randomSample, formulaHasVariant }) => {
    const { editorDetails } = useContext(EditorContext);

    const hasText = useMemo(() => {
        const previews = editorDetails.previews?.[0] as any;
        return previews?.content.message;
    }, [editorDetails.previews]);

    return (
        <Phone
            hasText={hasText}
            formulaHasVariant={formulaHasVariant}
            backgroundImageUrl={PREVIEW_SVG_URLS.whatsapp_android}
        >
            {randomSample.map((preview, i) => (
                <Message key={i + preview.id}>
                    {Object.values(preview.content).join()}
                </Message>
            ))}
        </Phone>
    );
};

export default WhatsappMain;

const Message = styled.div({
    backgroundColor: aampeTheme.colors.white,
    padding: aampeTheme.spacing(1.5),
    borderRadius: '16px',
    display: 'flex',
    color: aampeTheme.colors.gray800,
    fontSize: '12px',
    alignItems: 'center',
    width: '82%',
    boxShadow: aampeTheme.boxShadow.default,
    whiteSpace: 'pre-wrap',
});
